import { Link } from 'react-router-dom';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function NotFound() {
  usePageMeta({
    title: '页面未找到 - 无颜之月动漫第一季全集',
    description: '你访问的页面不存在。返回无颜之月动漫第一季全集首页，继续浏览完整剧集与剧情介绍。',
  });

  return (
    <div className="w-full min-h-[70vh] px-4 md:px-8 pt-32 pb-20 flex flex-col items-center justify-center text-center">
      <span className="w-20 h-20 flex items-center justify-center rounded-full bg-primary-500/15 text-primary-300 mb-5">
        <i className="ri-moon-foggy-line text-4xl"></i>
      </span>
      <p className="font-heading font-bold text-5xl md:text-6xl text-accent-400">404</p>
      <h1 className="mt-4 font-heading font-bold text-2xl text-foreground-50">页面未找到</h1>
      <p className="mt-3 text-sm text-foreground-400 max-w-md">
        你要找的页面像月光一样消失了。不如回到首页，继续追寻无颜之月第一季的故事。
      </p>
      <div className="mt-7 flex flex-col sm:flex-row gap-3">
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-2 rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-background-950 hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/category"
          className="inline-flex items-center justify-center gap-2 rounded-md bg-background-800/70 border border-primary-500/40 px-6 py-3 text-sm font-medium text-foreground-100 hover:bg-background-800 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-play-list-2-line"></i>
          浏览剧集
        </Link>
      </div>
    </div>
  );
}